var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMrCameras(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_710_5029)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 7.28571C6 6.57563 6.57563 6 7.28571 6H13.6876C14.3977 6 14.9733 6.57563 14.9733 7.28571C14.9733 7.99579 14.3977 8.57143 13.6876 8.57143H8.57143V13.6876C8.57143 14.3977 7.99579 14.9733 7.28571 14.9733C6.57563 14.9733 6 14.3977 6 13.6876V7.28571ZM51.0267 7.28571C51.0267 6.57563 51.6023 6 52.3124 6H58.7143C59.4244 6 60 6.57563 60 7.28571V13.6876C60 14.3977 59.4244 14.9733 58.7143 14.9733C58.0042 14.9733 57.4286 14.3977 57.4286 13.6876V8.57143H52.3124C51.6023 8.57143 51.0267 7.99579 51.0267 7.28571ZM7.28571 51.0267C7.99579 51.0267 8.57143 51.6023 8.57143 52.3124V57.4286H13.6876C14.3977 57.4286 14.9733 58.0042 14.9733 58.7143C14.9733 59.4244 14.3977 60 13.6876 60H7.28571C6.57563 60 6 59.4244 6 58.7143V52.3124C6 51.6023 6.57563 51.0267 7.28571 51.0267ZM58.7143 51.0267C59.4244 51.0267 60 51.6023 60 52.3124V58.7143C60 59.4244 59.4244 60 58.7143 60H52.3124C51.6023 60 51.0267 59.4244 51.0267 58.7143C51.0267 58.0042 51.6023 57.4286 52.3124 57.4286H57.4286V52.3124C57.4286 51.6023 58.0042 51.0267 58.7143 51.0267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4344 45.6V29.4541L22.7369 40.2769H20.0726L14.375 29.4541V45.6H10.2V21H14.7211L21.3874 33.7977L28.123 21H32.6094V45.6H28.4344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5386 45.6V21H47.4035C48.5339 21 49.5719 21.231 50.5177 21.693C51.4866 22.1549 52.317 22.7786 53.009 23.5639C53.7241 24.3493 54.2662 25.227 54.6353 26.1972C55.0275 27.1673 55.2235 28.1606 55.2235 29.1769C55.2235 30.2163 55.039 31.2211 54.6699 32.1913C54.3239 33.1383 53.8164 33.9699 53.1474 34.6859C52.4785 35.402 51.6942 35.9563 50.7945 36.349L55.2 45.6H49.9405L46.0887 37.3538H41.3136V45.6H36.5386ZM41.3136 33.1614H47.2997C47.8995 33.1614 48.4301 32.9882 48.8914 32.6417C49.3528 32.2721 49.7219 31.787 49.9987 31.1865C50.2755 30.5859 50.4139 29.9161 50.4139 29.1769C50.4139 28.3916 50.2524 27.7101 49.9295 27.1327C49.6065 26.5321 49.1913 26.0586 48.6838 25.7121C48.1994 25.3656 47.6688 25.1924 47.0921 25.1924H41.3136V33.1614Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_710_5029",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.8 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_710_5029"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_710_5029",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrCameras);
export default __webpack_public_path__ + "static/media/MR_cameras.8dfcbed266dc62a2a35e48cfc58f51d5.svg";
export { ForwardRef as ReactComponent };